import styled from 'styled-components'

export const ManageCurrencyListLinkStyled = styled.a`
  font-weight: ${(props) => props.theme.fontWeights.normal};
  white-space: nowrap;
`
